import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { IconInfoOutlined } from '@prisjakt/ui/icon/info-outlined';
import { FontEmphasis } from '@prisjakt/ui/text';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import { CaptionText } from '@prisjakt/ui/text/variants';
import * as S from './styles';
import type { ProductOfferAvailability } from 'src/types';

interface IPriceTypeNoticeBadge {
  priceAvailability?: ProductOfferAvailability | null;
}

export const PriceTypeNoticeBadge: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IPriceTypeNoticeBadge>>
> = props => {
  const { t } = useAppContext();

  const { priceAvailability } = props;

  if (!priceAvailability) {
    return null;
  }

  if (
    priceAvailability.condition !== 'Download' &&
    priceAvailability.condition !== 'NotAvailableForOrder'
  ) {
    return null;
  }

  const label =
    priceAvailability.condition === 'Download'
      ? t('product', 'price-notice.download')
      : t('product', 'price-notice.not_available_for_purchase');

  return (
    <S.PriceInfoElement>
      <Tooltip
        placement={TooltipPlacement.TOP}
        title={label as string}
        renderOnMouseOver
      >
        <S.IconWrapper>
          <IconInfoOutlined color="base300" />
        </S.IconWrapper>
      </Tooltip>
      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        {label as string}
      </CaptionText>
    </S.PriceInfoElement>
  );
};
